import {
  ApiBlueprint,
  createApiRef,
  createFrontendModule,
  configApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  type BackstageIdentityApi,
  type OAuthApi,
  type OpenIdConnectApi,
  type ProfileInfoApi,
  type SessionApi,
} from '@backstage/frontend-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { useApi } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { ManewcoSignInPage } from './ManewcoSignInPage';

/** Connexion OIDC (Keycloak, realm manewco). */
export const oidcAuthApiRef = createApiRef<
  OAuthApi &
    OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi
>({ id: 'internal.auth.oidc' });

const oidcAuthApi = ApiBlueprint.make({
  name: 'oidc',
  params: define =>
    define({
      api: oidcAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          discoveryApi,
          oauthRequestApi,
          // Depuis Backstage 1.55, sans configApi le retour de la popup est ignoré
          // et la connexion reboucle sans erreur.
          configApi,
          provider: { id: 'oidc', title: 'Keycloak', icon: () => null },
          defaultScopes: ['openid', 'profile', 'email'],
          environment: configApi.getOptionalString('auth.environment'),
        }),
    }),
});

// Page de connexion de la maquette « Clarté complète » (bouton « Continuer avec Manewco »).
const SignIn = (props: { onSignInSuccess: (identityApi: any) => void }) => (
  <ManewcoSignInPage authApi={useApi(oidcAuthApiRef)} onSignInSuccess={props.onSignInSuccess} />
);

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => SignIn,
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [oidcAuthApi, signInPage],
});
